import Box from "@mui/material/Box";
import {FC, useCallback, useContext, useEffect} from "react";
import {makeStyles} from "tss-react/mui";
import {Modal} from "@buildwitt/shapeshift-common/v2/modal";
import {Button, LinearProgress, Typography} from "@mui/material";
import {INotificationSeverity, NotificationContext, useApi} from "@buildwitt/shapeshift-identity";
import {cohortBaseUrl} from "../../../constants";

interface IProps {
	open: boolean,
	onClose: (reload?: boolean) => void,
	selected: {type: string, id: number, courseSlug: string}[],
	userId: number
}

const useStyles = makeStyles()((theme) => ({
	adminBulkUserTrainingRescheduleModal: {
		padding: theme.spacing(3),
		display: "flex",
		gap: theme.spacing(2),
		flexDirection: "column"
	},
	textUnderline: {
		textDecoration: "underline"
	}
}));

export const AdminBulkUserTrainingRescheduleModal: FC<IProps> = ({open, selected, userId, onClose}) => {
	const {classes} = useStyles();
	const {notify} = useContext(NotificationContext);
	const [rescheduleResponse, submitCompletionApi] = useApi<boolean>()

	const handleSubmitLessonCompletion = useCallback(() => {
		if(!open || rescheduleResponse.isLoading)
			return;

		submitCompletionApi({
			url: `${cohortBaseUrl}/users/${userId}/modules/reschedule/overdue`,
			method: "PUT",
			data: {
				modules: selected
			}
		})
	}, [open, rescheduleResponse.isLoading])

	useEffect(() => {
		if(rescheduleResponse.statusCode === 200){
			notify("", "Successfully rescheduled users", INotificationSeverity.success, 5000)
			onClose(true)
		}
		else if(rescheduleResponse.statusCode){
			notify("", "Failed to rescheduled users", INotificationSeverity.error, 5000)
			onClose()
		}
	}, [rescheduleResponse])

	return (
		<Modal
			open={open}
			footerButtons={[
				<Button key={1} onClick={() => onClose()}>CANCEL</Button>,
				<Button key={2} onClick={() => handleSubmitLessonCompletion()}>CONFIRM</Button>
			]}
			onClose={() => onClose()}
			aria-labelledby="modal-modal-title"
			title="Confirm Bulk Recchedule"
			aria-describedby="modal-modal-description"
		>
			<Box className={classes.adminBulkUserTrainingRescheduleModal}>
				<Typography variant="h5">Confirm Lesson Reschedule</Typography>
				<Typography variant="body1">
					This action will reschedule <span className={classes.textUnderline}>all lessons</span> in the user&apos;s Feed by pushing them back until none remain overdue, whilst continuing to respect the company&apos;s scheduled time off.<br/>
					Please note, the rescheduling process does not differentiate between auto-assigned training, prioritized training, or training with explicitly set due dates. The current order of lessons in the Feed will remain unchanged.<br/>
					Please confirm that you want to reschedule all overdue lessons.
				</Typography>
				{rescheduleResponse.isLoading && <LinearProgress />}
			</Box>
		</Modal>
	);
}